export default "__VITE_ASSET__Dvb9aQmW__"